/* global Modernizr */

import $ from 'jquery';
import 'slick-carousel';
import Plyr from 'plyr';
import Vue from 'vue';
import 'jquery.flipster';

import '../../../scss/app/news_article.scss';

const transformProp = Modernizr.prefixed('transform');

/*
 https://desandro.github.io/3dtransforms/docs/carousel.html
 */

function Carousel3D(el) {
  this.element = el;
  this.rotation = 0;
  this.panelCount = this.element.children.length;
  this.theta = 0;
  this.index = 0;
  return this;
}

Carousel3D.prototype.modify = function modify() {
  this.panelSize = this.element.offsetWidth;
  this.theta = 360 / this.panelCount;

  // do some trig to figure out how big the carousel is in 3D space
  this.radius = Math.round((this.panelSize / 2) / Math.tan(Math.PI / this.panelCount));

  for (let i = 0; i < this.panelCount; i += 1) {
    this.element.children[i].style[transformProp] = `rotateY(${(this.theta * i)}deg) translateZ(${this.radius}px)`;
  }

  // adjust rotation so panels are always flat
  this.rotation = Math.round(this.rotation / this.theta) * this.theta;
  this.transform();
};

Carousel3D.prototype.transform = function transform() {
  // push the carousel back in 3D space, and rotate it
  this.element.style[transformProp] = `translateZ(-${this.radius}px) rotateY(${this.rotation}deg)`;
  for (let i = 0; i < this.panelCount; i += 1) {
    this.element.children[i].style.opacity = i === this.index ? 1 : 0.8;
  }
};

Carousel3D.prototype.prev = function prev() {
  this.rotation += this.theta * -1 * -1;
  this.index -= 1;
  if (this.index < 0) {
    this.index = this.panelCount - 1;
  }
  this.transform();
};

Carousel3D.prototype.next = function next() {
  this.rotation += this.theta * 1 * -1;
  this.index += 1;
  if (this.index > this.panelCount - 1) {
    this.index = 0;
  }
  this.transform();
};

Carousel3D.prototype.goToIndex = function goToIndex(index) {
  this.rotation = this.theta * index * -1;
  this.index = index;
  this.transform();
};

Carousel3D.prototype.destroy = function destroy() {
  this.element.style[transformProp] = 'none';
  for (let i = 0; i < this.panelCount; i += 1) {
    this.element.children[i].style[transformProp] = 'none';
    this.element.children[i].style.opacity = 1;
  }
};

//
// Business logic
//

const Article = Vue.extend({
  template: '#article-template',
  data() {
    return {
      modalOpen: false,
      modalPhoto: null,
    };
  },
  props: {
    hasVideo: Boolean,
    srcPhotos: Array,
    photoUrlTemplate: String,
    photoDownloadUrlTemplate: String,
    filesUrl: String,
  },
  computed: {
    photos() {
      return this.srcPhotos.map((photo) => {
        const alteredPhoto = photo;
        alteredPhoto.shareUrl = this.getPhotoUrl(photo);
        alteredPhoto.downloadUrl = this.getPhotoDownloadUrl(photo);
        return alteredPhoto;
      });
    },
  },
  methods: {
    getPhotoBackgroundStyle(src) {
      return `url("${src}")`;
    },
    getPhotoUrl(photo) {
      return this.photoUrlTemplate.replace('0000', photo.id);
    },
    getPhotoDownloadUrl(photo) {
      return this.photoDownloadUrlTemplate.replace('0000', photo.id);
    },
    onPhotoClicked(photo) {
      this.showPhotoInModal(photo);
    },
    showPhotoInModal(photo) {
      this.modalPhoto = photo;
      this.$nextTick(() => {
        this.modalOpen = true;
      });
    },
    closeModal() {
      this.modalOpen = false;
      this.modalPhoto = null;
    },
    modalGoLeft() {
      const currentIdx = this.photos.indexOf(this.modalPhoto);
      this.modalPhoto = this.photos[currentIdx - 1 < 0 ? this.photos.length - 1 : currentIdx - 1];
    },
    modalGoRight() {
      const currentIdx = this.photos.indexOf(this.modalPhoto);
      this.modalPhoto = this.photos[currentIdx + 1 >= this.photos.length ? 0 : currentIdx + 1];
    },
  },
  watch: {
    modalOpen(newVal) {
      if (newVal) {
        this.$refs.modal.focus();
      }
    },
  },
  mounted() {
    const vm = this;

    this.$nextTick(() => {
      // if ('video' in this.$refs) {
      //   new Plyr(this.$refs.video, { autoplay: true });
      // }

      //
      // Modal keyboard shortcuts. Must be bound before the image slider.
      //

      $(this.$refs.modal).add(document).on('keydown', (ev) => {
        if (!this.modalOpen) {
          return true;
        }

        ev.stopPropagation();

        if (ev.keyCode === 27) {
          this.closeModal();
          return false;
        }

        // Left arrow
        if (ev.keyCode === 37) {
          this.modalGoLeft();
          return false;
        }

        // Right arrow
        if (ev.keyCode === 39) {
          this.modalGoRight();
          return false;
        }

        return true;
      });

      //
      // Photo boxes
      //

      const $photoButton = $('.js-photo-button');
      $photoButton.on('click', (ev) => {
        ev.preventDefault();
        const idx = $photoButton.index(ev.currentTarget);
        this.showPhotoInModal(this.photos[idx]);
      });

      //
      // Image slides
      //

      const $slides = $('.slides');

      $slides.on('click', '.slide', (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        const slideIdx = $(ev.currentTarget).closest('.slick-slide').data('slick-index');
        this.showPhotoInModal(this.photos[slideIdx]);
      });

      $slides.slick({
        infinite: true,
        speed: 300,
        slidesToShow: 6,
        slidesToScroll: 6,
        prevArrow: $('#slider-prev').html(),
        nextArrow: $('#slider-next').html(),
        responsive: [
          {
            breakpoint: window.APP.breakpoints.large.replace(/[^0-9]/g, ''),
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: window.APP.breakpoints.medium.replace(/[^0-9]/g, ''),
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });

      const mediumMql = window.matchMedia(`screen and (min-width: ${window.APP.breakpoints.medium})`);

      //
      // Image carousel
      //

      const $flipster = $('.my-flipster');
      if ($flipster.length) {
        $flipster.flipster({ start: 0 });
        $flipster.on('click', 'button', (ev) => {
          ev.preventDefault();
          vm.showPhotoInModal(vm.photos[$(ev.currentTarget).data('index')]);
        });
      }

      const $carouselWrap = $('.carousel-wrap');
      if ($carouselWrap.length) {
        const $carouselImages = $('.carousel__images');
        const $carouselPrev = $('.button--prev');
        const $carouselNext = $('.button--next');
        let slickInitialized = false;

        let carousel;

        const handleMediaQueryChangeCarousel = function handleMediaQueryChangeCarousel(mql) {
          if (mql.matches) {
            if (slickInitialized) {
              $carouselImages.slick('unslick');
            }
            $carouselWrap.addClass('carousel--3d');
            $carouselWrap.find('.carousel__controls').attr('aria-hidden', 'false');

            carousel = new Carousel3D($carouselImages[0]);
            carousel.modify();

            $carouselPrev.on('click.carousel', () => {
              carousel.prev();
            });
            $carouselNext.on('click.carousel', () => {
              carousel.next();
            });
            $carouselImages.children().on('click.carousel', (ev) => {
              ev.preventDefault();
              const index = $carouselImages.children().index(ev.currentTarget);
              if (carousel.index === index) {
                vm.showPhotoInModal(vm.photos[index]);
              } else {
                carousel.goToIndex(index);
              }
            });
          } else {
            $carouselWrap.removeClass('carousel--3d');
            $carouselWrap.find('.carousel__controls').attr('aria-hidden', 'true');
            $carouselPrev.off('click.carousel');
            $carouselNext.off('click.carousel');
            $carouselImages.children().off('click.carousel');
            if (carousel) {
              carousel.destroy();
            }
            $carouselImages.slick({
              arrows: false,
              mobileFirst: true,
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: false,
            });
            slickInitialized = true;
          }
        };

        // setTimeout to avoid FOUC styling problems in dev env
        setTimeout(() => {
          mediumMql.addListener(handleMediaQueryChangeCarousel);
          handleMediaQueryChangeCarousel(mediumMql);
        }, 2000);
      }
    });
  },
});

new Vue({ el: '.js-entry-point', components: { 'article-component': Article } });
